import React from 'react';

function GeneralPriceTable({ title, rates, depositMessage, extraMessage }) {
  return (
    <section className='grid w-full'>
      <div className='grid w-full px-6 sm:px-8 md:px-12 lg:px-24 lg:container lg:mx-auto'>
        <article className='grid bg-colour6 dark:bg-colour6 px-2 py-2 shadow-cardShadow lg:w-fit lg:px-2 lg:mx-auto'>
          <div className='grid relative gap-4 bg-colour4 dark:bg-colour4 justify-center px-2 py-4 shadow-cardShadow'>
            {/* Style */}
            <div className='w-2 h-2 bg-colour1 absolute top-2 left-2 rounded-full shadow-md'></div>
            <div className='w-2 h-2 bg-colour1 absolute top-2 right-2 rounded-full shadow-md'></div>
            <div className='w-2 h-2 bg-colour1 absolute bottom-2 left-2 rounded-full shadow-md'></div>
            <div className='w-2 h-2 bg-colour1 absolute bottom-2 right-2 rounded-full shadow-md'></div>
            {/* Article */}
            <h2 className='font-StencilW01 text-3xl text-colour1 dark:text-colour1 text-center'>
              {title}
            </h2>
            <table className='grid w-fit mx-auto'>
              <thead className='grid pb-2'>
                <tr className='grid grid-flow-col justify-between  font-StencilW01'>
                  <th className=''>Duration</th>
                  <th className=''>In Calls</th>
                </tr>
              </thead>
              <tbody className='grid gap-1'>
                {rates.map((rate, index) => (
                  <tr
                    key={index}
                    className='grid text-2xl lg:text-2xl font-StencilW01 grid-flow-col gap-6 lg:gap-44 justify-between border'
                  >
                    <td className=''>{rate.duration}</td>
                    <td className=''>{rate.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className='px-4'>
              <p className='mt-4 text-sm text-colour1 dark:text-colour1 text-center'>
                {depositMessage} <br />
                <span className='text-colour2 dark:text-colour2'>{extraMessage}</span>
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

export default GeneralPriceTable;
